import React from 'react';
import ReactDOM from 'react-dom/client';
import LanguageProvider from '././contexts/LanguageContext';
import './styles/global.css';
import './styles/swiper.min.css';
import Homepage from './pages/Homepage';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <LanguageProvider>
        <Homepage />
    </LanguageProvider>
);
